/*
  Bundle cart guard - assets/bundle-cart-guard.js
  Load from layout/theme.liquid on every page:
    <script src="{{ 'bundle-cart-guard.js' | asset_url }}" defer="defer"></script>

  The free gift in a bundle is a real €0 product. This script keeps it honest:
  - if the bundle's candles are removed (or reduced below the tier quantity), the gift line is removed
  - if the gift quantity is raised, it is capped at the allowed quantity (normally 1 per bundle)
  It relies on the hidden line properties written by the Bundle & Save block:
    _bundle          shared id of the lines that belong together
    _bundle_qty      candles required for the tier
    _bundle_gift     marks the gift line
    _bundle_gift_qty allowed gift quantity
*/
(function () {
  'use strict';
  if (window.__bundleCartGuard) return;
  window.__bundleCartGuard = true;

  var busy = false;
  var pending = false;
  var timer = null;
  var ownRequest = false;

  function cartPath(path) {
    var root = (window.routes && window.routes.cart_url) || '/cart';
    return root.replace(/\/cart$/, '') + path;
  }

  function planChanges(cart) {
    var groups = {};
    cart.items.forEach(function (item, index) {
      var p = item.properties || {};
      var key = p._bundle;
      if (!key) return;
      var g = groups[key] || (groups[key] = { need: 0, candles: 0, gifts: [] });
      var need = parseInt(p._bundle_qty, 10) || 0;
      if (need > g.need) g.need = need;
      if (p._bundle_gift) {
        g.gifts.push({ line: index + 1, quantity: item.quantity, allowed: parseInt(p._bundle_gift_qty, 10) || 1 });
      } else {
        g.candles += item.quantity;
      }
    });

    var changes = [];
    Object.keys(groups).forEach(function (key) {
      var g = groups[key];
      g.gifts.forEach(function (gift) {
        var qualifies = g.need > 0 && g.candles >= g.need;
        var target = qualifies ? Math.min(gift.quantity, gift.allowed) : 0;
        if (target !== gift.quantity) changes.push({ line: gift.line, quantity: target });
      });
    });
    // Apply from the highest line index down so earlier indexes stay valid after removals.
    changes.sort(function (a, b) { return b.line - a.line; });
    return changes;
  }

  function applyChanges(changes) {
    return changes.reduce(function (chain, change) {
      return chain.then(function () {
        ownRequest = true;
        return fetch(cartPath('/cart/change.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: change.line, quantity: change.quantity })
        }).then(function (r) { return r.json(); }).finally(function () { ownRequest = false; });
      });
    }, Promise.resolve());
  }

  function refreshCartUi() {
    if (document.querySelector('cart-items') && !document.querySelector('cart-drawer')) {
      window.location.reload();
      return Promise.resolve();
    }
    var ids = ['cart-drawer', 'cart-icon-bubble'];
    return fetch(cartPath('/cart') + '?sections=' + ids.join(','), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parse = function (html, selector) {
          var doc = new DOMParser().parseFromString(html || '', 'text/html');
          return doc.querySelector(selector);
        };
        var drawerSource = parse(sections['cart-drawer'], '#CartDrawer');
        var drawerTarget = document.getElementById('CartDrawer');
        if (drawerSource && drawerTarget) drawerTarget.innerHTML = drawerSource.innerHTML;
        var bubbleSource = parse(sections['cart-icon-bubble'], '.shopify-section');
        var bubbleTarget = document.getElementById('cart-icon-bubble');
        if (bubbleSource && bubbleTarget) bubbleTarget.innerHTML = bubbleSource.innerHTML;
        var drawer = document.querySelector('cart-drawer');
        if (drawer) {
          var inner = drawer.querySelector('.drawer__inner');
          var empty = drawerSource && drawerSource.querySelector('.drawer__inner') && drawerSource.querySelector('.drawer__inner').classList.contains('is-empty');
          if (inner) inner.classList.toggle('is-empty', !!empty);
          drawer.classList.toggle('is-empty', !!empty);
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-cart-guard' });
        }
      });
  }

  function run() {
    if (busy) { pending = true; return; }
    busy = true;
    fetch(cartPath('/cart.js'), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var changes = planChanges(cart);
        if (!changes.length) return null;
        return applyChanges(changes).then(refreshCartUi);
      })
      .catch(function (err) { console.error('[bundle-cart-guard]', err); })
      .finally(function () {
        busy = false;
        if (pending) { pending = false; schedule(); }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 400);
  }

  // Run after any cart mutation made by the theme or by apps.
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = originalFetch.apply(this, arguments);
    if (!ownRequest && /\/cart\/(change|update|add|clear)/.test(url)) {
      result.then(function () { schedule(); }, function () {});
    }
    return result;
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'bundle-cart-guard') return;
      schedule();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
